"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MAIN_CONTENT_ID: true,
  KEY_CODE: true,
  generateId: true,
  getFocusableEls: true,
  propTypeError: true,
  bytesToKB: true,
  disableEmotionWarnings: true,
  formatBytes: true
};
exports.disableEmotionWarnings = exports.bytesToKB = exports.MAIN_CONTENT_ID = exports.KEY_CODE = void 0;
Object.defineProperty(exports, "formatBytes", {
  enumerable: true,
  get: function get() {
    return _formatBytes.default;
  }
});
exports.propTypeError = exports.getFocusableEls = exports.generateId = void 0;

var _muiSelectors = require("./mui-selectors");

Object.keys(_muiSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _muiSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _muiSelectors[key];
    }
  });
});

var _formatBytes = _interopRequireDefault(require("./formatBytes"));

var MAIN_CONTENT_ID = "main-content";
exports.MAIN_CONTENT_ID = MAIN_CONTENT_ID;
var KEY_CODE = {
  ARROWDOWN: "ArrowDown",
  ARROWUP: "ArrowUp",
  END: "End",
  ENTER: "Enter",
  ESC: "Escape",
  HOME: "Home",
  SPACE: " ",
  TAB: "Tab"
};
exports.KEY_CODE = KEY_CODE;

var generateId = function generateId() {
  var id = Math.random().toString(36).substring(2);
  /**
   * In CSS, identifiers (including element names, classes, and IDs in selectors)
   * can contain only the characters [a-zA-Z0-9] and ISO 10646 characters U+00A0
   * and higher, plus the hyphen (-) and the underscore (_); they cannot start
   * with a digit, two hyphens, or a hyphen followed by a digit.
   * */

  return "_".concat(id);
};

exports.generateId = generateId;

var getFocusableEls = function getFocusableEls() {
  var parentEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  return parentEl.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
};

exports.getFocusableEls = getFocusableEls;

var propTypeError = function propTypeError(propName, componentName) {
  var invalidType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "falsey";
  throw new Error("Warning: Failed prop type: The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(invalidType, "`."));
};

exports.propTypeError = propTypeError;

var bytesToKB = function bytesToKB(bytes) {
  return Math.floor(bytes * 0.001);
};
/**
 * Suppresses `&:first-child` console errors that stem from `@emotion`.
 *
 * See https://github.com/emotion-js/emotion/pull/1209 for more context.
 */


exports.bytesToKB = bytesToKB;

var disableEmotionWarnings = function disableEmotionWarnings() {
  var log = console.error.bind(console);

  console.error = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.indexOf("The pseudo class") && args.indexOf("is potentially unsafe when doing server-side rendering. Try changing it to")) {
      return;
    }

    log.apply(void 0, args);
  };
};

exports.disableEmotionWarnings = disableEmotionWarnings;